/**
 * Бейдж, запамʼятований на ЦЬОМУ пристрої (вхід одним натиском на власному
 * телефоні) — і чий він.
 *
 * Куплено 03.11.2026 (ТЗ2): після «Вийти» на спільному телефоні кнопка «✅ Увійти»
 * заходила ПОПЕРЕДНЬОЮ людиною й відкривала їй зміну — бейдж лишався в
 * localStorage, а чий він, ніде не писалось. Тепер явне «Вийти» його стирає
 * (`forgetDeviceBadge`), а екран входу показує ім'я власника.
 */
export const DEVICE_KEY = "mes-device-qr";
const NAME_KEY = "mes-device-name";

export function rememberDeviceBadge(token: string, name: string): void {
  localStorage.setItem(DEVICE_KEY, token);
  localStorage.setItem(NAME_KEY, name);
}

export function deviceBadgeName(): string | null {
  try {
    return localStorage.getItem(NAME_KEY);
  } catch {
    return null;
  }
}

export function forgetDeviceBadge(): void {
  try {
    localStorage.removeItem(DEVICE_KEY);
    localStorage.removeItem(NAME_KEY);
  } catch {
    /* сховище недоступне — і бейджа там нема */
  }
}
